export default __webpack_public_path__ + "static/media/13_giropay.65ae6cb3.svg";